module.exports = __webpack_public_path__ + "static/media/Minus_Icon_Billing.d28e9e77.svg";